import { AfterViewInit, Component, HostListener, Inject, OnInit, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, Event, ActivatedRoute } from '@angular/router';
import { Subscription, lastValueFrom } from 'rxjs';
import { MixpanelService } from './_shared/services/mixpanel/mixpanel.service';
import { StorageHelper } from './_utilities/storage-helper';
import { ContentStudioTrackingService } from './_shared/services/tracking/contentstudio-tracking.service';
import { TemplateHelperService } from './_shared/services/helper/template-selector/template-helper.service';
import { NewTemplateHelperService } from './_shared/services/helper/new-template-selector/new-template-helper.service';
import { GenerationInProgressHelperService } from './_shared/services/helper/generation-in-progress-popup/generation-in-progress-popup-helper.service';
import { MwcModalService } from 'mwc/modal';
import { CmsService } from './services/cms/cms.service';
import { isPlatformBrowser } from '@angular/common';
import { UserInfo } from './_shared/models/common';
import { CommonService } from './services/common/common.service';
import { FEATURES } from './_shared/consts/app-constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {

  @ViewChild('templateTitle', { read: TemplateRef }) templateSelectorTitle;
  @ViewChild('newTemplateTitle', { read: TemplateRef }) newTemplateSelectorTitle;
  isLoading: boolean = true;
  private _storageHelper: StorageHelper;
  mixPanelTrackingPaths = ['/dashboard', '/topic-ideas', '/manage-content/articles', '/settings', '/templates', '/manage-content/articles/manage-category','/campaigns/my-campaigns','/brand-voice','/target-audience']
  isSaasUser: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tracking: ContentStudioTrackingService,
    private modalService: MwcModalService,
    private templateHelperService: TemplateHelperService,
    private newtemplateHelperService: NewTemplateHelperService,
    private generationInProgressHelperService: GenerationInProgressHelperService,
    private commonService: CommonService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this._storageHelper = new StorageHelper();
    this.router.events.subscribe((event: Event) => {
      this._storageHelper = new StorageHelper();
      this.navigationInterceptor(event);
    });
  }
  ngOnInit(): void {
    //storing business id and profile alias in local storage -> Start
    if (isPlatformBrowser(this.platformId)) {
      this.route.queryParams.subscribe(param => {
      });
      const urlParams = new URLSearchParams(window.location.search);
      const businessId = urlParams.get('businessId');
      const profileAlias = urlParams.get('profileAlias');
      const contentGenerationId = urlParams.get('cgId');
      const source = urlParams.get('Source');
      if (businessId) {
        this._storageHelper.clear();
      }
      if (businessId) {
        this._storageHelper.setUserBusinessId(businessId);
      }
      else {
        if (this._storageHelper.user.bId === "") {
          this._storageHelper.setUserBusinessId('0');
        }
      }
      if (profileAlias) {
        this._storageHelper.setUserProfileAlias(profileAlias);
      }
      else {
        if (this._storageHelper.user.profileAlias === "") {
          this._storageHelper.setUserProfileAlias('');
        }
      }
      if (contentGenerationId) {
        this._storageHelper.setContentGenerationId(contentGenerationId);
      }
      else {
        if (this._storageHelper.user.contentGenerationId === "") {
          this._storageHelper.setContentGenerationId('');
        }
      }

      if (source === 'campaignsCTA') {
        this.commonService.getUserInfoValue().subscribe((res: UserInfo) => {
          if (res != null) {
            var isCampaignEnabled = res.featureIds?.includes(FEATURES.CampaignFeatureName) ?? false;
            if (isCampaignEnabled || res.isSaasUser) {
              this.router.navigate(['/campaigns/my-campaigns']);
            }
            else {
              this.router.navigate(['/dashboard']);
            }
          }        
        });
      }

      // Clean businessId and profileAlias from the URL after storing them
      if (businessId || profileAlias || contentGenerationId) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('businessId');
        currentUrl.searchParams.delete('profileAlias');
        currentUrl.searchParams.delete('cgId');
        window.history.replaceState({}, '', currentUrl.toString());
      }
    }   
    
    //storing business id and profile alias in local storage -> End
  }

  async navigationInterceptor(event: Event): Promise<void> {
    if (event instanceof NavigationStart) {
      this.isLoading = true;
    } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
      this.isLoading = false;
      const isTrackingPath = this.mixPanelTrackingPaths.includes(location.pathname);
      if (isTrackingPath) {
        const formattedPath = this.formatPath(location.pathname);
        this.tracking.trackEvent(
          'pageview', `${formattedPath}`
        );
        window.Appcues.page();
      }
    }
  }

  ngAfterViewInit(): void {
    //this.templateHelperService.init(this.modalService, this.templateSelectorTitle);
    this.newtemplateHelperService.init(this.modalService, this.newTemplateSelectorTitle);
    this.generationInProgressHelperService.init(this.modalService);
  }

  formatPath(path: string): string {
    const pathMap = {
      '/manage-content/articles': 'My Content',
      '/manage-content/articles/manage-category': 'Manage Category',
      '/dashboard': 'Dashboard',
      '/topic-ideas': 'Topic Ideas',
      '/settings': 'Settings',
      '/templates': 'Templates',
      '/campaigns/my-campaigns':'My Campaigns',
      '/brand-voice':'View Brand Voices',
      '/target-audience':'View Personas'
    };
    const formattedPath = pathMap[path] || path;
    return formattedPath
      .replace(/\//g, '')
      .replace(/-/g, ' ')
      .replace(/\b\w/g, match => match.toUpperCase());
  }

  ngOnDestroy() {
  }
}
